import Joi from '@hapi/joi';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// Email Validation
var email = Joi.string()
    .required()
    .email({ tlds: { allow: false } })
    .error(function () {
    return new Error("Please enter a valid email.");
});
// Password Validation
// could force users to be more secure ->
// https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
var password = Joi.string()
    .required()
    .min(8)
    .max(30)
    .error(function (errors) {
    return errors.map(function (error) {
        console.log(error);
        switch (error.code) {
            case "string.min":
                return new Error("Password must be greater than 8 Characters.");
            case "string.max":
                return new Error("Password must be fewer than 30 characters.");
            case "string.empty":
                return new Error("Please enter a password.");
            default:
                return new Error("Password validation error.");
        }
    });
});
// full name validation - only checks for first and last name via single space character
// all characters are valid, gotta support X Æ A-12 now
// should maybe fix, idk, it accepts stuff like Mike\tPollard
var fullName = Joi.string()
    .required()
    .pattern(new RegExp("^[^\\s]+(\\s[^\\s]+)+$"))
    .error(function () {
    return new Error("Please enter your first and last name");
});
// Phone number validation,internationally
var phoneNumber = Joi.string()
    .required()
    .custom(function (value, helpers) {
    var phone = parsePhoneNumberFromString("+".concat(value));
    if (!(phone === null || phone === void 0 ? void 0 : phone.isValid())) {
        return helpers.error("phone.invalid");
    }
    return value;
})
    .messages({
    "phone.invalid": "Please enter a valid phone number.",
});

export { email, fullName, password, phoneNumber };
//# sourceMappingURL=Validation.js.map
